module.exports = __webpack_public_path__ + "media/images/gerb_minzdrava-98d9bbf13594d463904258a2ec5de9fd.png";